import { Play, PlayCircle } from 'lucide-react';
import { Link, type LinkProps } from '@tanstack/react-router';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { HomeContinue } from '@/lib/api/home';

export function ContinueCard({ item, batchId = '' }: { item: HomeContinue | null; batchId?: string }) {
  if (!item) return null;
  const to = `/courses/${batchId}/topics/${item.topic_id}` as LinkProps['to'];
  return (
    <section aria-label="Continue learning">
      {/* Heading outside the card, matching the other dashboard sections. */}
      <h3 className="text-[16px] font-semibold leading-[24px] text-[#111827]">
        Continue Learning
      </h3>

      <div className="mt-4 flex flex-col gap-4 rounded-[20px] border border-[#f5e8e0] bg-gradient-to-br from-[#fff4f0] to-white p-[25px] shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
      <div className="flex items-center gap-4">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-[12px] bg-[#ff5a1f]">
          <PlayCircle className="size-5 text-white" />
        </div>
        <TooltipProvider delayDuration={300}>
          <div className="flex flex-col flex-1 gap-1 min-w-0">
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="cursor-default truncate text-[14px] font-semibold leading-[21px] text-[#111827]">
                  {item.module_title}
                </span>
              </TooltipTrigger>
              <TooltipContent>{item.module_title}</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="cursor-default truncate text-[11px] leading-[16.5px] text-[#9ca3af]">
                  Next up: {item.topic_title}
                </span>
              </TooltipTrigger>
              <TooltipContent>{item.topic_title}</TooltipContent>
            </Tooltip>
          </div>
        </TooltipProvider>
        <Link
          to={to}
          className="flex shrink-0 items-center gap-2 rounded-[12px] px-4 py-2 text-[13px] font-semibold leading-[19.5px] text-white shadow-[0_4px_8px_rgba(255,90,31,0.25)] transition-opacity hover:opacity-90"
          style={{ backgroundImage: 'linear-gradient(164.89deg, #ff6b3d 0%, #ff4d1a 100%)' }}
        >
          <Play className="size-[14px]" />
          <span>Resume</span>
        </Link>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="text-[11px] leading-[16.5px] text-[#9ca3af]">Progress</span>
          <span className="text-[11px] font-semibold leading-[16.5px] tabular-nums text-[#111827]">
            {Math.round(item.progress_pct)}%
          </span>
        </div>
        <div className="h-[5px] w-full overflow-hidden rounded-[10px] bg-[#f3f4f6]">
          <div
            className="h-full rounded-[10px] bg-[#ff5a1f]"
            style={{ width: `${item.progress_pct}%` }}
          />
        </div>
      </div>
      </div>
    </section>
  );
}
